// extracted by mini-css-extract-plugin
export default {"cargo_card":"CargoCard_cargo_card__5esgw","img_in_cargo_card":"CargoCard_img_in_cargo_card__2+SKC"};